import { axiosInstance } from "@/config/axios";
import { objectToCamel } from "ts-case-convert";
import { Contract } from "@/types/contract";
import { z } from "zod";
import { generatedContractSchema } from "@/types/schemas/contract";
import { ContractOptions, mapToBackend } from "@/utils";

export const updateContract = async (uuid: string, contract: Contract, contractOptions: ContractOptions): Promise<Contract> => {
  const updatedContract = mapToBackend(uuid, contract, contractOptions);
  const response = await axiosInstance.put(`/contract/${uuid}`, updatedContract);

  const parsedResponse = z.object({ contract: generatedContractSchema }).safeParse(objectToCamel(response.data));
  if (!parsedResponse.success) {
    console.error(parsedResponse.error.issues);
    throw new Error("zod error");
  }

  return {
    ...contract,
    uuid,
    phase: parsedResponse.data.contract.phase,
    customer: {
      ...contract.customer,
      customerId: parsedResponse.data.contract.customerId,
    },
    crmObjectId: parsedResponse.data.contract.crmObjectId,
    executivePeople: parsedResponse.data.contract.executivePeople,
    supplyPoint: parsedResponse.data.contract.supplyPoint,
    processSpecificationId: parsedResponse.data.contract.processSpecificationId,
  };
};

export const generateContract = async (uuid: string, contract: Contract) => {
  const updatedContract = mapToBackend(uuid, contract, { generateContract: true });
  const response = await axiosInstance.put(`/contract/${uuid}`, updatedContract);

  const parsedResponse = z.object({ contract: generatedContractSchema }).safeParse(objectToCamel(response.data));
  if (!parsedResponse.success) {
    console.error(parsedResponse.error.issues);
    throw new Error("zod error");
  }
  return parsedResponse.data.contract;
};
